import { useLazyQuery, useMutation, useQuery, useReactiveVar } from "@apollo/client";
import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
// import { HiBan } from "react-icons/hi";
// import { RiCheckFill, RiCloseFill } from "react-icons/ri";


import {
  Navigate,
  Link as LinkWrap,
  useNavigate,
  useParams,
} from "react-router-dom";
import { ClassificationCategories, useHitlFilters } from "..";
import { ComponentLoading } from "../../../components/loading/ComponentLoading";
import {
  GET_PRECISION_CATEGORIES_OPTIONS,
  GET_REVIEWED_URL,
  RESOLVE_URL_CATEGORY,
} from "../../../graphql/operations/campaignOperations/operations";
import { MultipleChoiceSection } from "./MultipleChoiceSection";
import { TitleLink } from "../TitleLink";
import { ToastNotificationBox } from "../../../components/toastNotificationBox/ToastNotificationBox";
import { useToast } from "@chakra-ui/react";
import { sideNavBodyDimensionsVar } from "../../../lib/cache";
import { GET_URL_CLASSIFICATION } from "../../../graphqlExternal/operations/operations";
import { CategorisationResultsType } from "../../../graphqlExternal/generated";
import { makeTypenameNonEnumerable } from "../../../utils/makeNonEnumerable";
import { decodeURL, encodeURL } from "../../../utils/encodeUrl";

export const UrlReview = () => {
  const url = decodeURL(useParams().url || "");
  const navigate = useNavigate();
  const dimensions = useReactiveVar(sideNavBodyDimensionsVar);

  const hitlFilters = useHitlFilters();
  const [chosenClassification, setChosenClassification] = useState<
    Record<string, string[]>
  >({});
  const [rejectedClassification, setRejectedClassification] = useState<
    Record<string, string[]>
  >({});

  const [, setForceUpdate] = useState(false);

  const toast = useToast();
  const toastId = "url-review-toast";

  const { data, loading } = useQuery(GET_REVIEWED_URL, {
    skip: !url,
    variables: {
      url: url,
    },
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (!data || !data.reviewedUrl.originalClassification) {
        urlDbQuery();
      }
    },
    onError: () => {
      urlDbQuery();
    }
  });

  const [
    urlDbQuery,
    { data: urlDbData, loading: urlDbLoading }
  ] = useLazyQuery(GET_URL_CLASSIFICATION, {
    context: { clientName: "illumaDbEndpoint", type: "graphql" },
    variables: {
      publisher: hitlFilters.publisherFilter.value,
      url: url,
    },
    fetchPolicy: "cache-and-network"
  });


  const {
    data: dataPrecision,
    error: errorPrecision,
    loading: loadingPrecision,
  } = useQuery(GET_PRECISION_CATEGORIES_OPTIONS, {
    fetchPolicy: "cache-and-network",
  });

  // May not need to refetch and just go the next entry in urlList
  const [resolveUrlCategory, { loading: loadingMutation }] = useMutation(
    RESOLVE_URL_CATEGORY,
    {
      onCompleted: () => {
        if (hitlFilters.urlList.length === 1) {
          navigate("/publisher/human-in-the-loop/url-list");
        } else if (url) {
          goToNextUrl(hitlFilters.urlList, url, navigate);
        }
      },
      // refetchQueries: [GET_URL_CLASSIFICATION]
    }
  );

  if (loading || urlDbLoading || loadingPrecision) {
    return <ComponentLoading text={"Loading URLs..."} />;
  }

  if (errorPrecision || !url) { // urlDbError
    return <>Error</>;
  }

  // if ((!urlDbData || urlDbData.urlClassification === null || urlDbData.urlClassification.pageUrl === null) && !data) {
  //   return <Navigate to={"../../"} />;
  // }

  // Redirect when either no url db data or no original classification illumaland db data
  if (!urlDbData?.urlClassification && (!data?.reviewedUrl?.originalClassification || data?.reviewedUrl?.originalClassification === null)) {
    return <Navigate to={"../../"} />;
  }

  // const classificationResults: UrlType = urlDbData.urlClassification;
  const mainClassifications: [string, string[]][] = [];
  const entityClassifications: [string, string[]][] = [];

  //const classificationEntries = Object.entries(classificationResults.results);
  let classificationResults: CategorisationResultsType;

  if (data && data.reviewedUrl.originalClassification && data.reviewedUrl.originalClassification !== null) {
    // Assignment for data from illumaland_db
    classificationResults = JSON.parse(data.reviewedUrl.originalClassification);
  } else {
    // Assignment for data from url_db
    classificationResults = urlDbData.urlClassification.results;
  }

  const classificationEntries: [string, string[] | "CategorisationResultsType"][] = Object.entries(classificationResults);

  // Modify entries so that all results are in the correct format,
  // especially illuma_sent as it is originally a string
  const modifiedEntries: [string, string[]][] = classificationEntries.map(
    (entry) => {
      // if (entry[0] === "illuma_sent") {
      //     const newEntry: [string, string[]] = [entry[0], ["negative", "neutral", "positive"]]
      //     return newEntry
      // }

      if (entry[1] === null) {
        const newEntry: [string, string[]] = [entry[0], []];
        return newEntry;
      }

      if (Array.isArray(entry[1])) {
        const newEntry: [string, string[]] = [entry[0], entry[1]];
        return newEntry;
      } else {
        const newEntry: [string, string[]] = [entry[0], [entry[1]]];
        return newEntry;
      }
    }
  );

  // Split entity classifications and main classifications
  modifiedEntries.forEach((classification) => {
    if (classification[0].includes("ents")) {
      entityClassifications.push(classification);
    } else if (classification[0].includes("typename")) {
      // pass
    } else {
      mainClassifications.push(classification);
    }
  });

  // Order classifications

  const orderedMainClassifications = mainClassifications.sort(compare);
  const orderedEntityClassifications = entityClassifications.sort(compare);

  return (
    <Box>
      <Flex
        bgColor={"white"}
        // borderRadius={"lg"}
        p={0}
        mb={20}
        direction={"column"}
      >
        <TitleLink
          url={url}
          // Only show note when more than one category
          showNote={false}
          showLink={true}
        />
        <Flex
        p={3}
          flexWrap={["nowrap", null, "wrap", null, null]}
          flexDirection={["column", null, "row", null, null]}
        >
          {orderedMainClassifications.map((classification, ix) => {
            return (
              <MultipleChoiceSection
                key={ix}
                index={ix}
                objectKey={classification[0]}
                objectValue={classification[1]}
                setChosenCategories={setChosenClassification}
                setRejectedCategories={setRejectedClassification}
                setForceUpdate={setForceUpdate}
                chosenClassification={chosenClassification}
                dataPrecision={dataPrecision}
              />
            );
          })}
          {orderedEntityClassifications.length > 0 && (
            <>
              <React.Fragment>
                <Divider borderColor={"muted"} />
                <Text
                  width={"100%"}
                  fontSize={"18px"}
                  my={2}
                  ml={6}
                  fontWeight={"semibold"}
                >
                  {formatSubSectionHeader("ENTITIES")}
                </Text>
                {orderedEntityClassifications.map(
                  (entityClassification, iy) => {
                    return (
                      <MultipleChoiceSection
                        key={iy}
                        index={iy}
                        objectKey={entityClassification[0]} //`${subCategory[0]}_${category}`}
                        objectValue={entityClassification[1]}
                        setChosenCategories={setChosenClassification}
                        setRejectedCategories={setRejectedClassification}
                        setForceUpdate={setForceUpdate}
                        chosenClassification={chosenClassification}
                        dataPrecision={dataPrecision}
                      />
                    );
                  }
                )}
              </React.Fragment>
            </>
          )}
        </Flex>
      </Flex>
      <Flex
        bg={"white"}
        justifyContent={["flex-end", null, "center", null, null]}
        py={2}
        position={"fixed"}
        bottom={8}
        left={dimensions?.contentBox.width/1.9}
        padding={3}
        width={"350px"}
        pr={5}
        borderWidth={"1px"}
        zIndex={2}
        boxShadow={"0 20px 20px #E8EBED"}
      >
        <HStack spacing={4}>
        <Button
            // leftIcon={<Icon as={HiBan} w={5} h={5} />}
            // bgColor={"#EAF0F2"}
            variant="unStyledSquare"
            onClick={() => {
              url && goToNextUrl(hitlFilters.urlList, url, navigate);
              setChosenClassification({});
            }}
          >
            Skip
          </Button>
        <LinkWrap to={'../../url-list'}>
            <Button
              // leftIcon={<Icon as={RiCloseFill} w={5} h={5} />}
              variant="whiteBoxButton"
              onClick={() => {
                url && goToNextUrl([], url, navigate);
              }}
            >
              Cancel
            </Button>
          </LinkWrap>

          <Button
            // leftIcon={<Icon as={RiCheckFill} w={5} h={5} />}
            variant="blueButton"
            isDisabled={
              Object.keys(removeEmpty(chosenClassification)).length === 0 &&
              Object.keys(removeEmpty(rejectedClassification)).length === 0
                ? true
                : false
            }
            isLoading={loadingMutation}
            onClick={() => {
              resolveUrlCategory({
                variables: {
                  url: url,
                  precisionIabV3: JSON.stringify(
                    classificationResults.precision_iab_v3
                  ),
                  publisher: hitlFilters.publisherFilter.value,
                  originalClassification: JSON.stringify(makeTypenameNonEnumerable(classificationResults)),
                  reviewedClassification:
                    Object.keys(removeEmpty(chosenClassification)).length === 0
                      ? null
                      : JSON.stringify(removeEmpty(chosenClassification)),
                  rejectedClassification:
                    Object.keys(removeEmpty(rejectedClassification)).length ===
                    0
                      ? null
                      : JSON.stringify(removeEmpty(rejectedClassification)),
                },
              })
                .then(() => {
                  toast({
                    id: toastId,
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right",

                    render: () => {
                      return (
                        <ToastNotificationBox
                          content="Changes submitted"
                          borderLeftColor={"submitGreen.default"}
                          backgroundColor={"submitGreen.light"}
                          borderColor={"submitGreen.light"}
                          borderLeftWidth={4}
                          borderRadius={0}
                        />
                      );
                    },
                  });
                })
                .catch((err) => err);
            }}
          >
            Submit
          </Button>

        </HStack>
      </Flex>
    </Box>
  );
};

const removeEmpty = (obj: Record<string, string[]>) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v.length !== 0)
  );
};

// Function used to order classification
const compare = (a: [string, string[]], b: [string, string[]]) => {
  if (a[1].length > b[1].length) {
    return -1;
  }
  if (a[1].length < b[1].length) {
    return 1;
  }
  return 0;
};

const formatSubSectionHeader = (header: string) => {
  let formattedHeader = header;

  switch (header) {
    case ClassificationCategories.entities:
      formattedHeader = "ENTITIES";
      break;
  }

  return formattedHeader;
};

const goToNextUrl = (
  urlList: string[],
  url: string,
  navigate: (path: string) => void
) => {
  let index = urlList.findIndex((item) => item === url);
  let nextUrl = urlList[index + 1];

  // If the next URL is a duplicate of current URL get the last index of
  // that URL then try to go to next index
  if (nextUrl === urlList[index]) {
    index = urlList.lastIndexOf(url);
    nextUrl = urlList[index + 1];
  }

  if (urlList.length - 1 > index) {
    navigate(`../../${encodeURL(nextUrl)}/review`);
  } else {
    navigate("../../url-list");
  }

  // if (hitlFilters.selectedIndex === hitlFilters.urlList.length - 1) {
  //   hitlFilters.setSelectedIndex(0);
  //   hitlFilters.setSelectedUrl(hitlFilters.urlList[0]);
  // } else {
  //   hitlFilters.setSelectedIndex(hitlFilters.selectedIndex + 1);
  //   hitlFilters.setSelectedUrl(
  //     hitlFilters.urlList[hitlFilters.selectedIndex + 1]
  //   );
  // }
};
